import React, {useEffect} from 'react';
import Final from "../../components/Final";
import './indes.scss'
import Header from "../../components/header";
import {useLocation} from "react-router-dom";
const FinalPage = () => {
    const location = useLocation();
    useEffect(()=>{
        console.log((location.pathname).indexOf('final'), 2222)
        if((location.pathname).indexOf('final') === 1){
            document.body.style.overflow='inherit'
        }
    },[location])
    return (
        <div className={'FinalPage'}>
            <Header/>
            <Final/>
        </div>
    );
};

export default FinalPage;
